import React, { useState } from "react";
import { Link, animateScroll as scroll } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import PropTypes from "prop-types";
import Button from "../Button/Button";

import "./Navbar.css";

function Navbar(props) {
  const { home } = props;

  const [click, setClick] = useState(false);
  const [button, setButton] = useState(window.innerWidth <= 960 ? false : true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const scrollToTop = () => {
    scroll.scrollToTop();
    setClick(false);
  };

  window.addEventListener("resize", showButton);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar">
          <div className="navbar__container">
            {home ? (
              <div className="navbar__logo" onClick={scrollToTop}>
                <img className="navbar__icon-image" src="images/icon.png" />
                Workom
              </div>
            ) : (
              <a href="/" className="navbar__logo" onClick={closeMobileMenu}>
                <img className="navbar__icon-image" src="images/icon.png" />
                Workom
              </a>
            )}
            <div className="menu__icon" onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </div>
            <ul className={click ? "nav__menu active" : "nav__menu"}>
              <li className="nav__item">
                {home ? (
                  <Link
                    to="top"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={800}
                    className="nav__links"
                    onClick={closeMobileMenu}
                  >
                    トップ
                  </Link>
                ) : (
                  <a href="/" className="nav__links" onClick={closeMobileMenu}>
                    トップ
                  </a>
                )}
              </li>
              <li className="nav__item">
                {home ? (
                  <Link
                    to="product"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={800}
                    className="nav__links"
                    onClick={closeMobileMenu}
                  >
                    機能
                  </Link>
                ) : (
                  <a
                    href="/#product"
                    className="nav__links"
                    onClick={closeMobileMenu}
                  >
                    機能
                  </a>
                )}
              </li>
              <li className="nav__item">
                {home ? (
                  <Link
                    to="feature"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={800}
                    className="nav__links"
                    onClick={closeMobileMenu}
                  >
                    特徴
                  </Link>
                ) : (
                  <a
                    href="/#product"
                    className="nav__links"
                    onClick={closeMobileMenu}
                  >
                    特徴
                  </a>
                )}
              </li>
              <li className="nav__btn">
                {button ? (
                  home ? (
                    <Link
                      to="download"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={800}
                      className="btn--link"
                    >
                      <Button buttonStyle="btn--primary">ダウンロード</Button>
                    </Link>
                  ) : (
                    <a href="/#download" className="nav__links">
                      <Button buttonStyle="btn--primary">ダウンロード</Button>
                    </a>
                  )
                ) : home ? (
                  <Link
                    to="download"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={800}
                    className="btn--link"
                    onClick={closeMobileMenu}
                  >
                    <Button buttonStyle="btn--primary" buttonSize="btn--mobile">
                      ダウンロード
                    </Button>
                  </Link>
                ) : (
                  <a
                    href="/#download"
                    className="btn--link"
                    onClick={closeMobileMenu}
                  >
                    <Button buttonStyle="btn--primary" buttonSize="btn--mobile">
                      ダウンロード
                    </Button>
                  </a>
                )}
              </li>
            </ul>
          </div>
        </div>
      </IconContext.Provider>
    </>
  );
}

Navbar.propTypes = {
  home: PropTypes.bool,
};

export default Navbar;
